export class UserProfile {
  userId: string | undefined;

  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  userRoleType: string | undefined;
  selectedRoleTypes: string[] | undefined;

  phoneNumber: string | undefined;
  providerOneId: string | undefined;
  displayInitials: string | undefined;

  addressLine1: string | undefined;
  addressLine2: string | undefined;
  formattedAddress: string | undefined;
  city: string | undefined;
  state: string | undefined;
  country: string | undefined;
  zipcode: string | undefined;

  latitude: string | undefined;
  longitude: string | undefined;

  billingAcknowledgement: boolean = false;

  active: boolean = true;
  createdAt: string | undefined;
  createdBy: string | undefined;
  modifiedAt: string | undefined;
  modifiedBy: string | undefined;
}
